const handlePaywall = () => {
    const paywall = document.getElementsByClassName('js-podcast-paywall');

    if (typeof rmgPaywall === 'undefined') {
        return false;
    }

    return rmgPaywall && paywall !== 'undefined' && paywall.length;
};

document.addEventListener("DOMContentLoaded", () => {

    if (handlePaywall()) {
        rmgPaywall.checkArticle(rmn_pod_vars.post_id, {}, function (access, context) {
            if (!access) {
                return;
            }

            jQuery.ajax( {
                url      : rmn_pod_vars.ajaxurl,
                data     : {
                    action: 'get_podcast_prem_content',
                    post_id: rmn_pod_vars.post_id,
                    nonce: rmn_pod_vars.nonce
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
    
                if (true !== response.success) {
                    return;
                }
                
                let contentContainers = document.getElementsByClassName('podcast-episode-embed');

                if (contentContainers.length) {
                    contentContainers[0].innerHTML = response.data.content;
                }
            });
        });
    }
});
